import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Grid2"
import Box from "@mui/material/Box"

import PaymentCard from "./PaymentCard"
import IndexCard from "./IndexCard"
import MetricCarousel from "./MetricCards/MetricCarousel"
import DashboardTable from "./DashboardTable"

import useMetricCards from "./MetricCards/metricCards"


const Dashboard = ({ supabase }) => {

    const cards= useMetricCards(supabase)
    const cardSize= { xs: 12, sm: 6, md: 4, lg: 3, xl: 2, xxl: 1 }

    return (
        <>
            <MetricCarousel
                cards={cards}
                cardSize={cardSize}
            />

            <Box sx={{ width: "100%", mt: 4 }}>
                <Grid container spacing={4}>
                    <Grid size={{ xs: 12, lg: 5 }}>
                        <Stack direction="column" spacing={2}>
                            <Typography component="h2" variant="h4">
                                Suggestions
                            </Typography>
                            <PaymentCard supabase={supabase} />
                            <IndexCard supabase={supabase} />
                        </Stack>
                    </Grid>
                    <Grid size={{ xs: 12, lg: 7 }}>
                        <Stack direction="column" spacing={2}>
                            <Typography component="h2" variant="h4">
                                Biens
                            </Typography>
                            <DashboardTable supabase={supabase} />
                        </Stack>
                    </Grid>
                </Grid>
            </Box>
        </>
    )
}

export default Dashboard
